import { createUseStyles } from 'react-jss'
import { formLink } from '../../../../styles/common/drawerForms'

const useStyles = createUseStyles({
  warningMessage: {
    marginTop: 60
  },
  warningIcon: {
    textAlign: 'center'
  },
  description: {
    '& a': {
      extend: formLink
    }
  }
})

export default useStyles
